import dayjs from "dayjs";
import { FormField } from "src/helpers";
import * as Yup from "yup";

export const NEWSLETTER_SUBSCRIBE_FORM_FIELDS: FormField[] = [
  {
    label: "Campaign Name",
    dataKey: "campaign_name",
    componentType: "input",
    componentProps: {
      type: "text",
      readonly: true,
    },
  },
  {
    label: "Email",
    dataKey: "email",
    componentType: "input",
    componentProps: {
      type: "text",
      readonly: true,
    },
  },
  {
    label: "Mobile No",
    dataKey: "phonenumber",
    componentType: "input",
    componentProps: {
      type: "number",
      maxLength: 10,
      placeholder: "Ex:9XXXXXXXXX",
    },
  },
];

export const INITIAL_NEWSLETTER_SUBSCRIBE_FORM_VALUES = {
  email: "",
  phonenumber: "",
  campaign_name: "",
};

export const NEWSLETTER_SUBSCRIBE_FORM_VALIDATION_SCHEMA = Yup.object().shape({
  email: Yup.string().email("Invalid email address").required("Email is required"),

  phonenumber: Yup.string().required("Your Mobile No is required").length(10, "Phone number must be exactly 10 digits"),

  campaign_name: Yup.string()
    .min(2, "Campaign name must be at least 2 characters")
    .required("Campaign name is required"),
});
